import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { Link } from "gatsby"
import "../../assets/scss/demo.css"

import pindukBg from "../../assets/img/basarihikayeleri-image/casestudypage_pinduk.webp"
import toyotaBg from "../../assets/img/basarihikayeleri-image/toyota-case-study.webp"
import stmBg from "../../assets/img/basarihikayeleri-image/stm-case-study.webp"
import tcddBg from "../../assets/img/basarihikayeleri-image/tcdd-case-study.webp"
import stmTwoBg from "../../assets/img/basarihikayeleri-image/stm-case-study-two.webp"
import livaBg from "../../assets/img/basarihikayeleri-image/liva-case-study.webp"
import mocacoBg from "../../assets/img/basarihikayeleri-image/mocaco-case-study.webp"
import lovaBg from "../../assets/img/basarihikayeleri-image/lova-case-study.webp"
import camHotelBg from "../../assets/img/basarihikayeleri-image/cam-hotel-case-study.webp"
import unwomenBg from "../../assets/img/basarihikayeleri-image/unwomen-case-study.webp"
import livaTwoBg from "../../assets/img/basarihikayeleri-image/liva-two-case-study.webp"
import mocacoTwoBg from "../../assets/img/basarihikayeleri-image/mocaco-case-two.webp"
import uksBg from "../../assets/img/basarihikayeleri-image/uks-case-study.webp"
import aybaMetalBg from "../../assets/img/basarihikayeleri-image/ayba-metal-case-study.webp"
import yolcu360Bg from "../../assets/img/basarihikayeleri-image/yolcu-360-case-study.webp"
import milliPiyangoBg from "../../assets/img/basarihikayeleri-image/milli-piyango-case-study.webp"
import pakmayaBg from "../../assets/img/basarihikayeleri-image/pakmaya-case-study.webp"
import robesnmoreBg from "../../assets/img/basarihikayeleri-image/robesnmore-case-study.webp"
import enerjisaBg from "../../assets/img/basarihikayeleri-image/enerjisa-case-study.webp"
import tanotoBg from "../../assets/img/basarihikayeleri-image/tanoto-case-study.webp"
import kuruyemisBorsaBg from "../../assets/img/basarihikayeleri-image/kuruyemis-borsa-case-study.webp"
import colorantBg from "../../assets/img/basarihikayeleri-image/colorant-case-study.webp"
import arcadiumBg from "../../assets/img/basarihikayeleri-image/arcadium-case-study.webp"
import fullaModaBg from "../../assets/img/basarihikayeleri-image/fulla-moda-case-study.webp"
import kentparkBg from "../../assets/img/basarihikayeleri-image/kentpark-case-study.webp"
import ecantaBg from "../../assets/img/basarihikayeleri-image/ecanta-case.webp"
import villaPreBg from "../../assets/img/basarihikayeleri-image/villa-pre-case-study.webp"
import forecrBg from "../../assets/img/forecrbackground.png"

import pindukLogo from "../../assets/img/basarihikayeleri-image/logolar/download.webp"
import toyotaLogo from "../../assets/img/basarihikayeleri-image/logolar/toyota-logo.webp"
import stmLogo from "../../assets/img/basarihikayeleri-image/logolar/stm-logo.webp"
import tcddLogo from "../../assets/img/basarihikayeleri-image/logolar/logo2.png"
import livaLogo from "../../assets/img/basarihikayeleri-image/logolar/liva-case-study-logo.webp"
import mocacoLogo from "../../assets/img/basarihikayeleri-image/logolar/mocaco-logo-case.webp"
import lovaLogo from "../../assets/img/basarihikayeleri-image/logolar/loda-case-study-logo.webp"
import camHotelLogo from "../../assets/img/basarihikayeleri-image/logolar/cam-hotel-case-logo.webp"
import unwomenLogo from "../../assets/img/basarihikayeleri-image/logolar/unwoman-case-logo.webp"
import uksLogo from "../../assets/img/basarihikayeleri-image/logolar/uks-yapi-case-logo.webp"
import aybaLogo from "../../assets/img/basarihikayeleri-image/logolar/ayba-metal-case-logo.webp"
import yolcu360Logo from "../../assets/img/basarihikayeleri-image/logolar/yolcu-360-case-logo.webp"
import milliPiyangoLogo from "../../assets/img/basarihikayeleri-image/logolar/milli-piyango-case-study-logo.webp"
import pakmayaLogo from "../../assets/img/basarihikayeleri-image/logolar/pakmaya-case-logo.webp"
import robesnmoreLogo from "../../assets/img/basarihikayeleri-image/logolar/robesNmore-white-logo-case.webp"
import enerjisaLogo from "../../assets/img/basarihikayeleri-image/logolar/enerjisa-case-logo.webp"
import tanotoLogo from "../../assets/img/basarihikayeleri-image/logolar/tanoto-case-logo.webp"
import kuruyemisBorsasiLogo from "../../assets/img/basarihikayeleri-image/logolar/kuruyemis_borsasi-logo.webp"
import sefaStoneLogo from "../../assets/img/basarihikayeleri-image/logolar/sefa-stone-case.webp"
import arcadiumLogo from "../../assets/img/basarihikayeleri-image/logolar/Arcadium-logo.webp"
import fullamodaLogo from "../../assets/img/basarihikayeleri-image/logolar/fullamoda-case-logo.webp"
import kentparkLogo from "../../assets/img/basarihikayeleri-image/logolar/kentpark-case-logo.webp"
import ecantaLogo from "../../assets/img/basarihikayeleri-image/logolar/ecanta_logo-case.webp"
import villaPreLogo from "../../assets/img/basarihikayeleri-image/logolar/villa-pre-logo-case.webp"
import forecrLogo from "../../assets/img/forecrlogo.png"
import arrowIcon from "../../assets/img/arrow-icon.png"

const SuccessStories = () => (
  <Layout>
    <SEO
      title="Success Stories | Flatart"
      description="Click to see our success stories where we showcase our expertise in digital marketing!"
    />
    <div>
      <div className="container">
        <div className="mt-5 mb-3">
          <h1 className="text-black"><strong>Real Success Stories</strong></h1>
          <p>
            Statistics from some of our clients who have experienced the impact of our
            services and special strategies.
          </p>
        </div>

        <div className="row">
          {/* Pinduk */}
          <div className="col-xs-12 text-white pinduk">
            <div className="position-relative herotwo" style={{ backgroundImage: `url(${pindukBg})` }}>
              <div className="mask z-2 position-absolute"></div>
              <img src={pindukLogo} alt="pinduk logo" className="position-absolute top-0 z-3 m-5 testing pinduk" style={{ width: "190px" }} loading="lazy" />
              <div className="position-absolute bottom-0 z-3 m-5">
                <h3 className="float">Domestic Hazelnut Brand</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">%62</h2>
                    <p className="small-text mt-3 moc">Organic Traffic<br />Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+%148</h2>
                    <p className="small-text mt-3 moc">Add-to-Cart<br />Conversion Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+%137</h2>
                    <p className="small-text mt-3 moc">New User<br />Count Increase</p>
                  </div>
                </div>
                <Link to="/success-stories/pinduk/">
                  <p className="d-flex justify-content-center align-items-center gap-1 news">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>
          </div>

          {/* Toyota */}
          <div className="col-xs-12 text-white">
            <div className="position-relative herotwo" style={{ backgroundImage: `url(${toyotaBg})` }}>
              <div className="mask z-2 position-absolute"></div>
              <img src={toyotaLogo} alt="toyota logo" className="position-absolute top-0 z-3 m-5 testing" style={{ width: "150px" }} loading="lazy" />
              <div className="position-absolute bottom-0 z-3 m-5">
                <h3 className="float">Automotive Company</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">+%62</h2>
                    <p className="small-text mt-3 news">Organic Traffic User<br />& Session Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+107,000</h2>
                    <p className="small-text mt-3">New Keyword Visibility</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+%195</h2>
                    <p className="small-text mt-3">Form Conversion Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+12</h2>
                    <p className="small-text mt-3">Months of Collaboration</p>
                  </div>
                </div>
                <Link to="/success-stories/toyota/">
                  <p className="d-flex justify-content-center align-items-center gap-1 news">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>
          </div>

          {/* STM */}
          <div className="col-xs-12 text-white testing">
            <div className="position-relative herotwo" style={{ backgroundImage: `url(${stmBg})` }}>
              <div className="mask z-2 position-absolute"></div>
              <img src={stmLogo} alt="stm logo" className="position-absolute top-0 z-3 m-5 testings" style={{ width: "150px" }} loading="lazy" />
              <div className="position-absolute bottom-0 z-3 m-5">
                <h3 className="float">Global Defense Industry Company</h3>
                <div className="d-flex gap-3 my-3 testing">
                  <div className="border-start ps-2">
                    <h2 className="float">+%22</h2>
                    <p className="small-text mt-3 news">Organic<br />Traffic Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+%27.7</h2>
                    <p className="small-text mt-3">Follower Acquisition</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+6 MO</h2>
                    <p className="small-text mt-3">Collaboration Period</p>
                  </div>
                </div>
                <Link to="/success-stories/stm/">
                  <p className="d-flex justify-content-center align-items-center gap-1 news">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>
          </div>

          {/* FORECR & STM Two */}
          <div className="col-xs-6">
            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${forecrBg})` }}>
              <img src={forecrLogo} alt="FORECR logo" className="position-absolute top-0 z-3 m-4 testing save" style={{ width: "140px" }} loading="lazy" />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">Military-Grade Computer Manufacturer</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">+%257</h2>
                    <p className="small-text mt-3 moc">Organic<br />Traffic Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+8X</h2>
                    <p className="small-text mt-3 moc">Paid Channel<br />Revenue Growth</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">6</h2>
                    <p className="small-text mt-3 moc">Target<br />Locations</p>
                  </div>
                </div>
                <Link to="/success-stories/forecr/">
                  <p className="d-flex justify-content-center text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>

            <div className="position-relative img-3 my-4" style={{ backgroundImage: `url(${stmTwoBg})` }}>
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">Global Defense Industry Company</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float test text s">+(-35.48%)</h2>
                    <p className="small-text mt-3 testing text">PPC I AVG. CPC</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float test">+87.31%</h2>
                    <p className="small-text mt-3">Impressions</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float test">+125.71%</h2>
                    <p className="small-text mt-3">Clicks</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float test">+12 MO</h2>
                    <p className="small-text mt-3">Collaboration Period</p>
                  </div>
                </div>
              </div>
              <img src={stmLogo} alt="stm logo" className="position-absolute bottom-0 end-0 z-3 m-4 testing" style={{ width: "120px" }} />
            </div>
          </div>

          {/* Liva & TCDD */}
          <div className="col-xs-6">
            <div className="position-relative img-3 my-4" style={{ backgroundImage: `url(${livaBg})` }}>
              <div className="mask z-2 position-absolute"></div>
              <img src={livaLogo} alt="liva logo" className="position-absolute top-0 end-0 z-3 m-4 testing" style={{ width: "150px", left: 0 }} />
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">Local Pastry Company</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">+%15</h2>
                    <p className="small-text mt-3 lh-sm">E-Commerce<br />Conversion Rate</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+4,500</h2>
                    <p className="small-text mt-3 lh-sm">Monthly Orders<br />and Counting</p>
                  </div>
                </div>
                <Link to="/success-stories/liva-pastacilik-case-study/">
                  <p className="d-flex justify-content-center text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>

            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${tcddBg})` }}>
              <img src={tcddLogo} alt="tcdd logo" className="position-absolute top-0 z-3 m-4 testing" style={{ width: "100px" }} />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">National Transportation Company</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">+%24</h2>
                    <p className="small-text mt-3">Conversion Rate Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+%125</h2>
                    <p className="small-text mt-3">Organic Traffic Increase</p>
                  </div>
                </div>
                <Link to="/success-stories/tcdd-tasimacilik/">
                  <p className="d-flex justify-content-center text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>
          </div>

          {/* Lova */}
          <div className="col-xs-12 text-white">
            <div className="position-relative herotwo" style={{ backgroundImage: `url(${lovaBg})` }}>
              <div className="mask z-2 position-absolute"></div>
              <img src={lovaLogo} alt="lova logo" className="position-absolute top-0 z-3 m-5 testingls" style={{ width: "150px" }} loading="lazy" />
              <div className="position-absolute bottom-0 z-3 m-5">
                <h3 className="float">Luxury Furniture & Decoration</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">+%239</h2>
                    <p className="small-text mt-3 loda">Paid Traffic<br />Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+%230</h2>
                    <p className="small-text mt-3 loda">Lead Gen.<br />Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">6</h2>
                    <p className="small-text mt-3 loda">Campaign<br />Targeting<br />Locations</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float testings">+6 MO</h2>
                    <p className="small-text mt-3 loda">Collaboration Period</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Cam Hotel & Unwomen */}
          <div className="col-xs-6">
            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${camHotelBg})` }}>
              <img src={camHotelLogo} alt="cam hotel logo" className="position-absolute top-0 z-3 m-4 testing save" style={{ width: "100px" }} loading="lazy" />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">Thermal Resort Spa & Convention Center</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">+%150</h2>
                    <p className="small-text mt-3">Organic Traffic Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+12 MO</h2>
                    <p className="small-text mt-3">Collaboration Period</p>
                  </div>
                </div>
                <Link to="/success-stories/cam-hotel/">
                  <p className="d-flex justify-content-center text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>

            <div className="position-relative img-3 my-4" style={{ backgroundImage: `url(${unwomenBg})` }}>
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">International Organization</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">17M</h2>
                    <p className="small-text mt-3">Audience Reach</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">220k</h2>
                    <p className="small-text mt-3">Project Participation</p>
                  </div>
                </div>
                <Link to="/success-stories/un-women/">
                  <p className="d-flex justify-content-center text-white align-items-center gap-1 testing">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
              <img src={unwomenLogo} alt="unwomen logo" className="position-absolute bottom-0 end-0 z-3 m-4 testing un" style={{ width: "110px" }} loading="lazy" />
            </div>
          </div>

          {/* Liva Two & Mocaco Two */}
          <div className="col-xs-6">
            <div className="position-relative img-3 my-4" style={{ backgroundImage: `url(${livaTwoBg})` }}>
              <div className="mask z-2 position-absolute"></div>
              <img src={livaLogo} alt="liva logo" className="position-absolute top-0 end-0 z-3 m-4 testing" style={{ width: "150px", left: 0 }} loading="lazy" />
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">Local Pastry Company</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">%5.79</h2>
                    <p className="small-text mt-3 lh-sm">E-Commerce<br />Organic Traffic</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+90k</h2>
                    <p className="small-text mt-3 lh-sm">Monthly Organic<br />Traffic Acquired</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+4,500</h2>
                    <p className="small-text mt-3 lh-sm">Monthly Orders<br />and Counting</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+%61</h2>
                    <p className="small-text mt-3 lh-sm">Monthly Repeat<br />Order Rate</p>
                  </div>
                </div>
                <Link to="/success-stories/liva-pastacilik/">
                  <p className="d-flex justify-content-center text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>

            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${mocacoTwoBg})` }}>
              <img src={mocacoLogo} alt="mocaco logo" className="position-absolute top-0 z-3 m-5 testing" style={{ width: "100px" }} loading="lazy" />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-5">
                <h3 className="float">Local Café & Restaurant</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float moc">+%22</h2>
                    <p className="small-text mt-3 moc">Organic Traffic Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moc">+%27.7</h2>
                    <p className="small-text mt-3 moc">Follower Acquisition</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moc">+%27.7</h2>
                    <p className="small-text mt-3 moc">Follower Acquisition</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moc">+%27.7</h2>
                    <p className="small-text mt-3 moc">Follower Acquisition</p>
                  </div>
                </div>
                <Link to="/success-stories/mocaco/">
                  <p className="d-flex text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Row 2: UKS & Ayba Metal */}
        <div className="row">
          <div className="col-xs-6">
            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${uksBg})` }}>
              <img src={uksLogo} alt="uks logo" className="position-absolute top-0 z-3 m-4 testing save" style={{ width: "120px" }} loading="lazy" />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float moc">Waterproofing & Construction Chemicals Company</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float moc">+%26.85</h2>
                    <p className="small-text mt-3 moc">Organic<br />Traffic Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moc">+%160</h2>
                    <p className="small-text mt-3 moc">Collaboration<br />Period</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moc">+%403</h2>
                    <p className="small-text mt-3 moc">Impressions</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moc">+6 MO</h2>
                    <p className="small-text mt-3 moc">Collaboration<br />Period</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xs-6">
            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${aybaMetalBg})` }}>
              <img src={aybaLogo} alt="ayba logo" className="position-absolute top-0 z-3 m-5 testing ayba" style={{ width: "160px" }} loading="lazy" />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-5">
                <h3 className="float">Drywall & Prefab Structure Manufacturer</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float moc">+%104</h2>
                    <p className="small-text mt-3 moc">Organic<br />Traffic Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moc">+%84</h2>
                    <p className="small-text mt-3 moc">Total<br />Clicks</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moc">+%257.33</h2>
                    <p className="small-text mt-3 moc">Impressions</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moc">+6 MO</h2>
                    <p className="small-text mt-3 moc">Collaboration<br />Period</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Row 3: Yolcu360, Milli Piyango, Pakmaya, Robesnmore */}
        <div className="row">
          <div className="col-xs-6">
            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${yolcu360Bg})` }}>
              <img src={yolcu360Logo} alt="yolcu 360 logo" className="position-absolute top-0 z-3 m-4 testing save" style={{ width: "150px" }} loading="lazy" />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">National Car Rental Platform</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">+%24</h2>
                    <p className="small-text mt-3">Conversion Rate</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">-%12</h2>
                    <p className="small-text mt-3 gain">Cost-Per-Click<br />Reduction</p>
                  </div>
                </div>
                <Link to="/success-stories/yolcu360/">
                  <p className="d-flex justify-content-center text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>

            <div className="position-relative img-3 my-4" style={{ backgroundImage: `url(${milliPiyangoBg})` }}>
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">National Lottery Platform</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">+125k</h2>
                    <p className="small-text mt-3 gain">User Increase in<br />Web Sessions</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+133m</h2>
                    <p className="small-text mt-3 gain">Ad<br />Impressions</p>
                  </div>
                </div>
                <Link to="/success-stories/milli-piyango/">
                  <p className="d-flex justify-content-center text-white align-items-center gap-1 testing">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
              <img src={milliPiyangoLogo} alt="milli piyango logo" className="position-absolute bottom-0 end-0 z-3 m-4 testing gain" style={{ width: "130px" }} loading="lazy" />
            </div>
          </div>

          <div className="col-xs-6">
            <div className="position-relative img-3 my-4" style={{ backgroundImage: `url(${pakmayaBg})` }}>
              <div className="mask z-2 position-absolute"></div>
              <img src={pakmayaLogo} alt="pakmaya logo" className="position-absolute top-0 end-0 z-3 m-4 pakmaya" style={{ width: "150px", left: 0 }} />
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">Global Food Company</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">10x</h2>
                    <p className="small-text mt-3 lh-sm">Organic Traffic<br />Growth</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+%126</h2>
                    <p className="small-text mt-3 lh-sm">Expanding the<br />Audience Reached</p>
                  </div>
                </div>
                <Link to="/success-stories/pakmaya/">
                  <p className="d-flex justify-content-center text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>

            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${robesnmoreBg})` }}>
              <img src={robesnmoreLogo} alt="robesnmore logo" className="position-absolute top-0 z-3 m-5 testing robes" style={{ width: "180px" }} loading="lazy" />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-5">
                <h3 className="float">Towel & Bathrobe Wholesale Supplier</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float moc">+%132</h2>
                    <p className="small-text mt-3 moc">Organic<br />Traffic Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moc">+44%</h2>
                    <p className="small-text mt-3 moc">New<br />Users</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moc">+22%</h2>
                    <p className="small-text mt-3 moc">E-Commerce<br />Purchase Conversion</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moc">+12 MO</h2>
                    <p className="small-text mt-3 moc">Collaboration<br />Period</p>
                  </div>
                </div>
                <Link to="/success-stories/robesnmore/">
                  <p className="d-flex text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Row 4: Enerjisa, Tanoto, Kuruyemis, Sefa Stone, Arcadium, Fullamoda, Kentpark */}
        <div className="row">
          <div className="col-xs-12 text-white">
            <div className="position-relative herotwo" style={{ backgroundImage: `url(${enerjisaBg})` }}>
              <div className="mask z-2 position-absolute"></div>
              <img src={enerjisaLogo} alt="enerjisa logo" className="position-absolute top-0 z-3 m-5 testing ener" style={{ width: "150px" }} loading="lazy" />
              <div className="position-absolute bottom-0 z-3 m-5">
                <h3 className="float">National Energy Company</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">+8.2k</h2>
                    <p className="small-text mt-3 moc">"Ayedaş"<br />Keywords</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+6.5K</h2>
                    <p className="small-text mt-3 moc">"Başkent Edaş"<br />Keywords</p>
                  </div>
                </div>
                <Link to="/success-stories/enerjisa/">
                  <p className="d-flex justify-content-center align-items-center gap-1 news">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-xs-6">
            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${tanotoBg})` }}>
              <img src={tanotoLogo} alt="tanoto logo" className="position-absolute top-0 z-3 m-4 testing tan" style={{ width: "150px" }} loading="lazy" />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">Local Automotive Brand</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">+750k</h2>
                    <p className="small-text mt-3 moc">View<br />Reach</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+%30</h2>
                    <p className="small-text mt-3 moc">Follower<br />Growth</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+24 MO</h2>
                    <p className="small-text mt-3 moc">Collaboration<br />Period</p>
                  </div>
                </div>
                <Link to="/success-stories/tanoto/">
                  <p className="d-flex justify-content-center text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-xs-6">
            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${kuruyemisBorsaBg})` }}>
              <img src={kuruyemisBorsasiLogo} alt="kuruyemis borsasi logo" className="position-absolute top-0 z-3 m-5 testing ayba" style={{ width: "160px" }} loading="lazy" />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-5">
                <h3 className="float">Online Dry Fruits Brand</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">+%186</h2>
                    <p className="small-text mt-3 moc">Conversion<br />Rate</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+%34</h2>
                    <p className="small-text mt-3 moc">Annual Revenue<br />Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+6 MO</h2>
                    <p className="small-text mt-3 moc">Collaboration<br />Period</p>
                  </div>
                </div>
                <Link to="/success-stories/kuruyemis-borsasi/">
                  <p className="d-flex text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-xs-6">
            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${colorantBg})` }}>
              <img src={sefaStoneLogo} alt="sefa stone logo" className="position-absolute top-0 z-3 m-4 testing sefas" style={{ width: "100px" }} loading="lazy" />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">Global Retail Company</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">%46</h2>
                    <p className="small-text mt-3 moc">More Customer<br />Conversions</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">%27</h2>
                    <p className="small-text mt-3 moc">2-Year Organic<br />Traffic Increase</p>
                  </div>
                </div>
                <Link to="/success-stories/sefa-stone/">
                  <p className="d-flex justify-content-center text-white align-items-center gap-1 testing">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>

            <div className="position-relative img-3 my-4" style={{ backgroundImage: `url(${arcadiumBg})` }}>
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">Local Shopping Mall</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">%172</h2>
                    <p className="small-text mt-3 moc">Revenue Increase<br />in 2 Years</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">%150</h2>
                    <p className="small-text mt-3 moc">2-Year Organic<br />Traffic Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+24 MO</h2>
                    <p className="small-text mt-3 moc">Collaboration<br />Period</p>
                  </div>
                </div>
                <Link to="/success-stories/arcadium/">
                  <p className="d-flex justify-content-center text-white align-items-center gap-1 testing">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
              <img src={arcadiumLogo} alt="arcadium logo" className="position-absolute bottom-0 end-0 z-3 m-4 testing arc" style={{ width: "90px" }} loading="lazy" />
            </div>
          </div>

          <div className="col-xs-6">
            <div className="position-relative img-3 my-4" style={{ backgroundImage: `url(${fullaModaBg})` }}>
              <div className="mask z-2 position-absolute"></div>
              <img src={fullamodaLogo} alt="fullamoda logo" className="position-absolute top-0 end-0 z-3 m-4 testing" style={{ width: "150px", left: 0 }} loading="lazy" />
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">National Fashion Brand</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">+%114.70</h2>
                    <p className="small-text mt-3 moc">Conversion<br />Rate Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+%279.20</h2>
                    <p className="small-text mt-3 moc">Revenue<br />Increase</p>
                  </div>
                </div>
                <Link to="/success-stories/fullamoda/">
                  <p className="d-flex justify-content-center text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>

            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${kentparkBg})` }}>
              <img src={kentparkLogo} alt="kentpark logo" className="position-absolute top-0 z-3 m-5 testing kent" style={{ width: "130px" }} loading="lazy" />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-5">
                <h3 className="float">Local Shopping Mall</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">%125</h2>
                    <p className="small-text mt-3 moc">Instagram<br />Follower Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+6m</h2>
                    <p className="small-text mt-3 moc">Monthly Users<br />Reached</p>
                  </div>
                </div>
                <Link to="/success-stories/kentpark/">
                  <p className="d-flex text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Row 5: Ecanta & Villa Pre */}
        <div className="row">
          <div className="col-xs-6">
            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${ecantaBg})` }}>
              <img src={ecantaLogo} alt="ecanta logo" className="position-absolute top-0 z-3 m-4 testing save" style={{ width: "120px" }} loading="lazy" />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-4">
                <h3 className="float">National Online Accessories Platform</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">+28k</h2>
                    <p className="small-text mt-3 moc">Organic<br />Traffic Growth</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+%26</h2>
                    <p className="small-text mt-3 moc">Ad Cost<br />Reduction</p>
                  </div>
                </div>
                <Link to="/success-stories/ecanta/">
                  <p className="d-flex justify-content-center text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-xs-6">
            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${villaPreBg})` }}>
              <img src={villaPreLogo} alt="villa pre logo" className="position-absolute top-0 z-3 m-5 testing ayba" style={{ width: "160px" }} loading="lazy" />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-5">
                <h3 className="float">National Prefab Company</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float">+%80</h2>
                    <p className="small-text mt-3 moc">Click-Through<br />Rate Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+%109</h2>
                    <p className="small-text mt-3 moc">Conversion Rate<br />Gain</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float">+24 MO</h2>
                    <p className="small-text mt-3 moc">Collaboration<br />Period</p>
                  </div>
                </div>
                <Link to="/success-stories/villa-yapi/">
                  <p className="d-flex text-white align-items-center gap-1">
                    <img src={arrowIcon} alt="" style={{ width: "25px" }} loading="lazy" />
                    View the details of the project
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Row 6: Mocaco */}
        <div className="row">
          <div className="col-xs-6">
            <div className="position-relative img-2 bg-black my-4" style={{ backgroundImage: `url(${mocacoBg})` }}>
              <img src={mocacoLogo} alt="mocaco logo" className="position-absolute top-0 z-3 m-5 testing" style={{ width: "100px" }} loading="lazy" />
              <div className="mask z-2 position-absolute"></div>
              <div className="position-absolute bottom-0 z-3 m-5">
                <h3 className="float">Local Café & Restaurant</h3>
                <div className="d-flex gap-3 my-3">
                  <div className="border-start ps-2">
                    <h2 className="float moca">+%25</h2>
                    <p className="small-text mt-3 loda">Organic<br />Traffic Increase</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moca">+%21</h2>
                    <p className="small-text mt-3 loda">Total<br />Clicks</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moca">+%112</h2>
                    <p className="small-text mt-3 loda">Impressions</p>
                  </div>
                  <div className="border-start ps-2">
                    <h2 className="float moca">+6 MO</h2>
                    <p className="small-text mt-3 loda">Collaboration<br />Period</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </Layout>
)

export default SuccessStories
